import React from "react"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"

import "../../styles/tabs.css"
import WhereEL from "../../img/whereEL.jpg"
import WherePT from "../../img/wherePT.jpg"
import WhereSC from "../../img/whereSC.jpg"
import WhereSF from "../../img/whereSF.jpg"
import WhereSH from "../../img/whereSH.jpg"
import WhereSW from "../../img/whereSW.png"
import WhereVM from "../../img/whereVM.jpg"
import WhereIC from "../../img/whereIC.jpg"
import WhereSE from "../../img/whereSE.jpg"

class WhereTo extends React.Component {
  constructor() {
    super()
    this.state = { tabIndex: 0 }
  }
  render() {
    return (
      <Tabs>
        <TabList>
          <Tab>
            <span>승강기</span>
          </Tab>
          <Tab>
            <span>주차타워</span>
          </Tab>
          <Tab>
            <span>스마트 벤딩머신</span>
          </Tab>
          <Tab>
            <span>스마트 팩토리</span>
          </Tab>
          <Tab>
            <span>스마트 물류</span>
          </Tab>
          <Tab>
            <span>ICS/SCADA</span>
          </Tab>
          <Tab>
            <span>보안 / 감시</span>
          </Tab>
          <Tab>
            <span>스마트 홈</span>
          </Tab>
          <Tab>
            <span>스마트 시티</span>
          </Tab>
        </TabList>
        <TabPanel>
          <p className="tabTextBox">
            <span>승강기</span> 승강기 업계의 유지관리 현황은 매우 위태롭습니다.
            법적 규정에 따른 자체점검, 정기검사, 자체정밀검사 등 수 많은 점검은
            물론 사용자의 요청에 따른 긴급호출 서비스까지 많은 일들을 적은
            유지보수 인력이 감당하기가 매우 어려운 실정입니다. 그렇다고
            엔지니어를 늘리기엔 기업운영의 어려움이 따따라 형식적인 유지관리가
            이루어지며 최근 계속해서 많은 사고들이 발생하고 있습니다. <br />
            <br />
            따라서, 정부에서는 최신 원격감시 기술을 적용한 현장에 대해서는
            점검주기를 다소 여유롭게 주고 집중적인 유지관리를 할 수 있게 정책을
            마련하였습니다. <br />
            ELSA Platform은 이러한 부분을 지원해줄 뿐만 아니라 승강기 유지관리에
            필요한 다양한 기능들을 제공하고있습니다. 단위 승강기 관리를 넘어서
            전체 승강기에 대한 자재 및 스케줄링을 유기적으로 관리하고 업무의
            효율을 높여보세요.
          </p>
          <p className="tabImgBox">
            <img src={WhereEL} alt="" />
          </p>
        </TabPanel>
        <TabPanel>
          <p className="tabTextBox">
            <span>주차타워</span> 주차타워 시장은 전 세계적으로 그야말로 뜨거운
            감자라고 할 수 있습니다. 계속해서 늘어나는 차량과 한정된
            주차공간으로 주차타워에 대한 수요는 지속적으로 증가하고 있습니다.
            하지만, 빈번한 사고발생과 일차원 적인 입출고 흐름으로 인해
            고객만족도는 높지않은 편입니다. <br />
            <br />
            ELSA Platform의 실시간 감시 및 제어기능, 고장 즉시알림(모바일) 등의
            기능을 이용하여 다양한 고객만족 서비스를 만들어나갈 수 있습니다.
            타워 내 고장발생시 즉각 출동, 제어기능을 이용한 새로운 서비스 출시
            등 이전에는 꿈꾸지 못했던 새로운 주차타워 시장을 개척해
            나아가보세요.
          </p>
          <p className="tabImgBox">
            <img src={WherePT} alt="" />
          </p>
        </TabPanel>
        <TabPanel>
          <p className="tabTextBox">
            <span>스마트 벤딩머신</span> 자판기 시장은 기존의 음료자판기의
            틀에서 벗어나 그 영역늘 넓혀가고있습니다. 특히, 일본 자판기는 그
            자체로 하나의 관광상품이 되었습니다. 그러나 음료, 과자, 담배,
            생활용품 등의 새로운 자판기 설치로 그 시장을 넓혀가는 것에 비해
            기존의 자판기에 대한 유지관리가 제대로 이루어지고 있지못한
            실정입니다. <br />
            ELSA Platform, 특히 ELSA IoT Gateway
            <span className="tmText">TM</span>가 새 자판기는 물론 기존의
            자판기와 함께할 때, 기존의 자판기에서는 상상할 수 없던 혁신을
            이뤄낼수 있습니다. 고객만족 서비스의 확장은 물론, 유지관리 비용
            절약, 그리고 GIS기반의 자판기 유지관리로 내 소중한 자산을
            지켜나가보세요.
          </p>
          <p className="tabImgBox">
            <img src={WhereVM} alt="" />
          </p>
        </TabPanel>
        <TabPanel>
          <p className="tabTextBox">
            <span>스마트 팩토리</span> IoT의 대표분야 중 하나인 스마트 팩토리.
            스마트 팩토리는 공장 내 기기들에 각종 센서가 설치되어 데이터가
            실시간으로 수집, 분석되어 공장내 모든 상황을 모니터링하고 이를
            분석해 목적된 바에 따라 자동으로 제어 하는것을 말합니다. 중요한 것은
            공장내 단위 기기들이아닌 모든 기기들이 마치 하나의 기계처럼 맞물려
            돌아갈수 있게 유기적으로 기기들을 연결하는 것이라고 볼 수 있습니다.
            <br />
            우리의 지능형 ELSA IoT Gateway<span className="tmText">TM</span>는
            기존의 각 기기들로부터 정보를 수집하고 ELSA Cloud로 전송합니다.
            ELSA.Cloud SaaS<span className="tmText">TM</span>는 단위별 정보들을
            유기적으로 결합하여 적재적소에 필요에 따라 적절한 제어를 전달할 수
            있습니다. 또한, 전체 현황에 대한 모니터링 및 관리 기능을 포함하고
            있어 이러한 공장관리시스템에 아주 적합합니다.
          </p>
          <p className="tabImgBox">
            <img src={WhereSF} alt="" />
          </p>
        </TabPanel>
        <TabPanel>
          <p className="tabTextBox">
            <span>스마트 물류</span> 인터넷의 발달로 전자상거래가 활성화됨에
            따라 원자재에서 부터 공정을 걸쳐 완제품을 소비자에 전달하기까지 신속
            정확하게 물자의 흐름을 관리할 필요성이 커지고 있습니다. 특히, 상품
            배송서비스는 그 자체로 기업의 이미지를 판단하는 하나의 척도로
            자리할만큼 중요한 위치를 차지하고 있습니다. 스마트 물류의 핵심은
            물류 전체의 과정 상의 화물의 정보, 자금흐름 등을 유연하게 연계시키고
            효율, 안전, 환경성 등을 달성하는데 있습니다. <br />
            <br />
            ELSA.Cloud SaaS<span className="tmText">TM</span> 서비스에서
            데이터를 통합 관리하고 현장의 직원들은 모바일 어플리케이션을 통해
            직접 필요한 정보를 조회, 입력 함으로써 물류 데이터의 정확성/신뢰성을
            높이고 일련의 흐름을 한눈에 확인할 수 있습니다. 물류와 자금의
            흐름관리를 통해 고효율 프로세스를 구축하고 정확한 재고 및 입출고
            관리를 해보세요.
          </p>
          <p className="tabImgBox">
            <img src={WhereSW} alt="" />
          </p>
        </TabPanel>
        <TabPanel>
          <p className="tabTextBox">
            <span>ICS/SCADA</span> ICS/SCADA, 공조 및 에너지관리 분야 역시
            스마트해지고 있습니다. 전력, 가스, 수도 및 교통시스템과 같은
            국가주요 기반시설이나 산업분야에 산재된 시스템을 유기적으로 연결하고
            모니터링 및 제어하여 국가 전체적인 업무 프로세스의 효율을 올리고
            민간에서 활용가능한 자료를 제공하기위해 많은 노력이
            이뤄지고있습니다. <br />
            2014년 한국수력원자력이 해킹당함에 따라 ICS/SCADA 분야의 보안에
            빨간불이 켜졌습니다. 이미 망 분리 및 최신 보안이 적용되어 있는
            것으로 알려져 있는 한수원이 해킹되고
          </p>
          <p className="tabImgBox">
            <img src={WhereIC} alt="" />
          </p>
        </TabPanel>
        <TabPanel>
          <p className="tabTextBox">
            <span>보안 / 감시</span> IoT시대를 맞아 스마트 홈, 스마트 시티,
            스마트 팩토리 등이 핵심 키워드로 부상함과 동시에 관련 기술로
            떠오르는것 중 하나가 바로 카메라입니다. 각 시설물들로부터 데이터를
            수집하고 분석하며 나아가 제어함에 있어서 현장의 안전이 확보되지 않은
            상태에서 제어하는것은 큰 인명사고를 초래할 수 있습니다. ELSA
            Platform에서는 Web RTC 기술을 활용하여 IP Camera를 통한 실시간 감시
            및 녹화 기능을 지원하고 있습니다. 카메라 관련 또 다른 이슈는 바로
            보안입니다. 최근, 집안에서 감시용 카메라를 통한 사생활 노출 문제가
            부각되고 있습니다. <br />
            ELSA는 통신간 글로벌 웹 보안 표준을 준수하며 데이터 암호화 처리를
            하여 보안 이슈에 대해 대응하고있습니다. ELSA의 주요 기능중 하나인
            감시기능은 공장, 물류, 시설물 어느 분야에서도 쓰일수 있으며 그
            활용도가 무궁무진합니다.
          </p>
          <p className="tabImgBox">
            <img src={WhereSE} alt="" />
          </p>
        </TabPanel>
        <TabPanel>
          <p className="tabTextBox">
            <span>스마트 홈</span> 스마트 홈은 가정에서 쉽게 접할수 있는
            IoT시대의 산물입니다. 일반적으로 자동화를 지원하는 개인 주택을
            가리키며 주로 모바일 어플리캐이션을 통해 원격 모니터링 및 제어를
            진행하게 됩니다. 요소로는 게이트웨이라는 중앙 허브와 이에 연결되는
            각종 장치와 센서들로 구성됩니다. 스마트 홈 분야의 현 주소는 사생활
            노출 문제가 심각하게 대두되고있으며, 각 장치들의 상호운용성이 높지
            않아 그 실용성이 높지 않은 편입니다. 우리의 ELSA Platform은 국제
            IoT표준을 준수하여 제품간 상호운용성이 매우 뛰어나며, 국제 웹보안
            표준을 따르고 있어 데이터 안전성이 높습니다. 실제로 Mozilla
            observatory로 부터 A+ 보안등급을 받고 지속적으로 보안 전문인력이
            유지관리하고 있습니다. 이제 ELSA를 활용하여 각 IoT제품들을
            유기적으로 연결하여 진정한 스마트홈의 시대와 만나보세요.
          </p>
          <p className="tabImgBox">
            <img src={WhereSH} alt="" />
          </p>
        </TabPanel>
        <TabPanel>
          <p className="tabTextBox">
            <span>스마트 시티</span> 지금까지 도시 내의 다양한 SOC 및 관련
            운용프로그램, 연구 및 개발 등에 있어서 서로 다른 부서에서 같은
            내용을 연구개발하거나 자원이 공유되지 않는 등, 부서간에 그리고
            시설물간에 서로 원활한 소통(연결)이 되지않아 많은 비용이 낭비되고
            있습니다. 따라서, 많은 선진국가에서는 비용낭비를 없애고자
            국가주도하에 스마트 시티산업이 시행되고 있습니다. 각 분야를
            유기적으로 연결하고 자원을 공유하며 도시에서 일어나는 일들에 대해
            중앙에서 통합 관리 및 분석하기 위함입니다. 이러한 스마트 시티 산업에
            있어서도 ELSA Platform은 도시 내의 다양한 솔루션들을 연결하고 자원을
            수집하며 빅데이터를 이용한 머신러닝을 통해 도시문제에 대한 새로운
            해결방안을 제시하는 등 핵심 역할을 담당할 수 있습니다.
          </p>
          <p className="tabImgBox">
            <img src={WhereSC} alt="" />
          </p>
        </TabPanel>
      </Tabs>
    )
  }
}
export default WhereTo
